// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "stripe_connect_integration".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "stripe_connect_integration" table (1:1 with a DB row, on the wire). */
export const stripeConnectIntegrationAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    connectedById: z.string().nullable(),
    stripeAccountId: z.string(),
    accountName: z.string().nullable(),
    accountEmail: z.string().nullable(),
    accountType: z.string(),
    chargesEnabled: z.boolean(),
    payoutsEnabled: z.boolean(),
    detailsSubmitted: z.boolean(),
    requirementsCurrentlyDue: z.unknown().nullable(),
    disabledReason: z.string().nullable(),
    isActive: z.boolean(),
    defaultCurrency: z.string().nullable(),
    lastSyncAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=stripeConnectIntegration.js.map